export default __webpack_public_path__ + "media/images/users/user-kathy-gordon-70x70-440354c1502d451ee1691560f3e59e3d.jpg";